import React from "react";
import { VehicleModel } from "../models/ServicePlanModels";
import { observer } from "mobx-react";
import ImgLazyLoad from "../../ImgLazyLoad";

export interface ServicePlanModelSelectorProps {
  vehicleModels?: VehicleModel[];
  handleModelChange: Function;
  selectedModel: string;
}

const ServicePlanModelSelector: React.SFC<ServicePlanModelSelectorProps> =
  observer((props) => {
    return (
      <div className="row col-lg-12  col-md-12 col-sm-12 col-xs-12 service-plan">
        {props.vehicleModels.map((model, i) => {
          return (
            <div
              key={i}
              className="sp-model col-lg-1 col-width col-md-2 col-sm-3 col-xs-4"
            >
              <a
                href="#"
                className={
                  model.modelID.toLocaleLowerCase() !==
                  props.selectedModel.toLocaleLowerCase()
                    ? "selected-model"
                    : "success-checkmark"
                }
                onClick={(e) => {
                  props.handleModelChange(e, model);
                }}
              >
                <ImgLazyLoad src={model.cpsModelImage} alt="Model image" />
                {model.modelDisplayName ? (
                  <div
                    className="sp-model-name"
                    dangerouslySetInnerHTML={{
                      __html: model.modelDisplayName,
                    }}
                  />
                ) : (
                  <div className="sp-model-name">
                    <p>
                      <span>{model.name}</span>
                    </p>
                  </div>
                )}
              </a>
            </div>
          );
        })}
      </div>
    );
  });

export default ServicePlanModelSelector;
